import { UploadFileByQrLinkParamKey } from '@/common/constants';

const keysToPreserve: string[] = [
  UploadFileByQrLinkParamKey.DOCUMENT_ID,
  UploadFileByQrLinkParamKey.EMPLOYEE_ID,
  UploadFileByQrLinkParamKey.QR_ID,
  UploadFileByQrLinkParamKey.VALID_TO,
];

export const clearLocalStorage = () => {
  Object.keys(localStorage).forEach((key) => {
    if (!keysToPreserve.includes(key)) {
      localStorage.removeItem(key);
    }
  });
};
